// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ffJ8k","type":"styles_type__Zq7If","choices":"styles_choices__bADtk"};